import { Link } from "react-router-dom";
import { ArrowRight, Home, Building2, Blocks, Landmark } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

const TYPES = [
  { icon: Home, label: "Residential" },
  { icon: Building2, label: "Commercial" },
  { icon: Blocks, label: "Mixed-Use" },
  { icon: Landmark, label: "Institutional Portfolios" },
];

export const PropertyTypes = () => (
  <section className="section bg-white" data-testid="property-types-section">
    <div className="container-x">
      <SectionHead eyebrow="Who It's For" title="Built for every portfolio." copy="ANFORD adapts to the way different properties are operated, monitored and managed." />
      <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:gap-5 lg:grid-cols-4">
        {TYPES.map((t, i) => (
          <Reveal key={t.label} delay={i * 0.06}>
            <Link to="/solutions" data-testid={`property-type-${t.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="group flex h-full flex-col items-start gap-4 rounded-2xl border border-navy/10 bg-mist/50 p-5 transition-[border-color,background-color] duration-300 hover:border-gold/40 hover:bg-white md:p-7">
              <t.icon className="h-6 w-6 text-navy transition-colors group-hover:text-gold" />
              <span className="font-display text-sm font-extrabold uppercase tracking-wide text-navy-ink md:text-base">{t.label}</span>
            </Link>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-10">
        <Link to="/solutions" data-testid="property-types-link" className="inline-flex min-h-[44px] items-center gap-2 font-display text-sm font-bold text-navy transition-colors hover:text-gold">
          Find your solution <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </div>
  </section>
);
